/**
 * Loyalty Program Catalog
 * cpp = cents per point (approximate average redemption value)
 * tiers: array of { name, min } thresholds (min = qualifying points/nights/segments per year)
 */

const LOYALTY_PROGRAMS = [
  // ─── AIRLINES ─────────────────────────────────────────────────────────────
  {
    id: 'united-mileageplus',
    name: 'United MileagePlus',
    category: 'airline',
    icon: 'flight',
    unit: 'miles',
    accentColor: '#003580',
    cpp: 1.2,
    tiers: [
      { name: 'Member', min: 0 },
      { name: 'Silver', min: 5000 },
      { name: 'Gold', min: 10000 },
      { name: 'Platinum', min: 15000 },
      { name: '1K', min: 54000 },
    ],
  },
  {
    id: 'delta-skymiles',
    name: 'Delta SkyMiles',
    category: 'airline',
    icon: 'flight',
    unit: 'miles',
    accentColor: '#E31837',
    cpp: 1.2,
    tiers: [
      { name: 'Member', min: 0 },
      { name: 'Silver Medallion', min: 5000 },
      { name: 'Gold Medallion', min: 10000 },
      { name: 'Platinum Medallion', min: 15000 },
      { name: 'Diamond Medallion', min: 35000 },
    ],
  },
  {
    id: 'aa-aadvantage',
    name: 'American AAdvantage',
    category: 'airline',
    icon: 'flight',
    unit: 'miles',
    accentColor: '#0078D2',
    cpp: 1.4,
    tiers: [
      { name: 'Member', min: 0 },
      { name: 'Gold', min: 25000 },
      { name: 'Platinum', min: 50000 },
      { name: 'Platinum Pro', min: 75000 },
      { name: 'Executive Platinum', min: 100000 },
    ],
  },
  {
    id: 'emirates-skywards',
    name: 'Emirates Skywards',
    category: 'airline',
    icon: 'flight',
    unit: 'miles',
    accentColor: '#C8102E',
    cpp: 1.1,
    tiers: [
      { name: 'Blue', min: 0 },
      { name: 'Silver', min: 25000 },
      { name: 'Gold', min: 50000 },
      { name: 'Platinum', min: 150000 },
    ],
  },
  {
    id: 'british-avios',
    name: 'British Airways Avios',
    category: 'airline',
    icon: 'flight',
    unit: 'Avios',
    accentColor: '#2B5F9E',
    cpp: 1.5,
    tiers: [
      { name: 'Blue', min: 0 },
      { name: 'Bronze', min: 300 },
      { name: 'Silver', min: 600 },
      { name: 'Gold', min: 1500 },
    ],
  },
  {
    id: 'southwest-rapidrewards',
    name: 'Southwest Rapid Rewards',
    category: 'airline',
    icon: 'flight',
    unit: 'points',
    accentColor: '#304CB2',
    cpp: 1.5,
    tiers: [
      { name: 'Member', min: 0 },
      { name: 'A-List', min: 35000 },
      { name: 'A-List Preferred', min: 70000 },
      { name: 'Companion Pass', min: 135000 },
    ],
  },
  {
    id: 'lufthansa-miles-more',
    name: 'Lufthansa Miles & More',
    category: 'airline',
    icon: 'flight',
    unit: 'miles',
    accentColor: '#05164D',
    cpp: 1.1,
    tiers: [
      { name: 'Base', min: 0 },
      { name: 'Frequent Traveller', min: 35000 },
      { name: 'Senator', min: 100000 },
      { name: 'HON Circle', min: 600000 },
    ],
  },
  {
    id: 'singapore-krisflyer',
    name: 'Singapore KrisFlyer',
    category: 'airline',
    icon: 'flight',
    unit: 'miles',
    accentColor: '#1B3B6F',
    cpp: 1.3,
    tiers: [
      { name: 'KrisFlyer', min: 0 },
      { name: 'Elite Silver', min: 25000 },
      { name: 'Elite Gold', min: 50000 },
    ],
  },
  {
    id: 'alaska-mileageplan',
    name: 'Alaska Mileage Plan',
    category: 'airline',
    icon: 'flight',
    unit: 'miles',
    accentColor: '#01426A',
    cpp: 1.8,
    tiers: [
      { name: 'Member', min: 0 },
      { name: 'MVP', min: 20000 },
      { name: 'MVP Gold', min: 40000 },
      { name: 'MVP Gold 75K', min: 75000 },
    ],
  },
  {
    id: 'air-france-flying-blue',
    name: 'Air France Flying Blue',
    category: 'airline',
    icon: 'flight',
    unit: 'miles',
    accentColor: '#002395',
    cpp: 1.2,
    tiers: [
      { name: 'Explorer', min: 0 },
      { name: 'Silver', min: 2500 },
      { name: 'Gold', min: 5000 },
      { name: 'Platinum', min: 10000 },
      { name: 'Ultimate', min: 20000 },
    ],
  },

  // ─── HOTELS ────────────────────────────────────────────────────────────────
  {
    id: 'marriott-bonvoy',
    name: 'Marriott Bonvoy',
    category: 'hotel',
    icon: 'hotel',
    unit: 'points',
    accentColor: '#8B1A2F',
    cpp: 0.8,
    tiers: [
      { name: 'Member', min: 0 },
      { name: 'Silver Elite', min: 10 },
      { name: 'Gold Elite', min: 25 },
      { name: 'Platinum Elite', min: 50 },
      { name: 'Titanium Elite', min: 75 },
      { name: 'Ambassador Elite', min: 100 },
    ],
  },
  {
    id: 'hilton-honors',
    name: 'Hilton Honors',
    category: 'hotel',
    icon: 'hotel',
    unit: 'points',
    accentColor: '#00367C',
    cpp: 0.6,
    tiers: [
      { name: 'Member', min: 0 },
      { name: 'Silver', min: 10 },
      { name: 'Gold', min: 40 },
      { name: 'Diamond', min: 60 },
    ],
  },
  {
    id: 'world-of-hyatt',
    name: 'World of Hyatt',
    category: 'hotel',
    icon: 'hotel',
    unit: 'points',
    accentColor: '#003B5C',
    cpp: 1.7,
    tiers: [
      { name: 'Member', min: 0 },
      { name: 'Discoverist', min: 10 },
      { name: 'Explorist', min: 30 },
      { name: 'Globalist', min: 60 },
    ],
  },
  {
    id: 'ihg-one-rewards',
    name: 'IHG One Rewards',
    category: 'hotel',
    icon: 'hotel',
    unit: 'points',
    accentColor: '#006F51',
    cpp: 0.5,
    tiers: [
      { name: 'Club', min: 0 },
      { name: 'Silver Elite', min: 10 },
      { name: 'Gold Elite', min: 20 },
      { name: 'Platinum Elite', min: 40 },
      { name: 'Diamond Elite', min: 70 },
    ],
  },
  {
    id: 'wyndham-rewards',
    name: 'Wyndham Rewards',
    category: 'hotel',
    icon: 'hotel',
    unit: 'points',
    accentColor: '#004B87',
    cpp: 0.9,
    tiers: [
      { name: 'Blue', min: 0 },
      { name: 'Gold', min: 15000 },
      { name: 'Platinum', min: 30000 },
      { name: 'Diamond', min: 45000 },
    ],
  },
  {
    id: 'radisson-rewards',
    name: 'Radisson Rewards',
    category: 'hotel',
    icon: 'hotel',
    unit: 'points',
    accentColor: '#1B3259',
    cpp: 0.4,
    tiers: [
      { name: 'Club', min: 0 },
      { name: 'Silver', min: 35000 },
      { name: 'Gold', min: 75000 },
      { name: 'Platinum', min: 175000 },
    ],
  },

  // ─── RETAIL / DINING ───────────────────────────────────────────────────────
  {
    id: 'starbucks-rewards',
    name: 'Starbucks Rewards',
    category: 'retail',
    icon: 'coffee',
    unit: 'stars',
    accentColor: '#00704A',
    cpp: 0.5,
    tiers: [
      { name: 'Green', min: 0 },
      { name: 'Gold', min: 300 },
    ],
  },
  {
    id: 'amazon-prime',
    name: 'Amazon Prime Rewards',
    category: 'retail',
    icon: 'shopping_bag',
    unit: 'points',
    accentColor: '#FF9900',
    cpp: 1.0,
    tiers: [{ name: 'Member', min: 0 }],
  },
  {
    id: 'target-circle',
    name: 'Target Circle',
    category: 'retail',
    icon: 'shopping_cart',
    unit: 'points',
    accentColor: '#CC0000',
    cpp: 1.0,
    tiers: [
      { name: 'Circle', min: 0 },
      { name: 'Circle 360', min: 0 },
    ],
  },
  {
    id: 'sephora-beauty-insider',
    name: 'Sephora Beauty Insider',
    category: 'retail',
    icon: 'spa',
    unit: 'points',
    accentColor: '#1B1818',
    cpp: 1.0,
    tiers: [
      { name: 'Insider', min: 0 },
      { name: 'VIB', min: 350 },
      { name: 'Rouge', min: 1000 },
    ],
  },
  {
    id: 'nike-membership',
    name: 'Nike Membership',
    category: 'retail',
    icon: 'sports_gymnastics',
    unit: 'points',
    accentColor: '#111111',
    cpp: 1.0,
    tiers: [{ name: 'Member', min: 0 }],
  },
];

export default LOYALTY_PROGRAMS;

export const LOYALTY_PROGRAMS_BY_ID = new Map(
  LOYALTY_PROGRAMS.map((p) => [p.id, p])
);

export const CATEGORIES = [
  { id: 'all', label: 'All' },
  { id: 'airline', label: 'Airlines' },
  { id: 'hotel', label: 'Hotels' },
  { id: 'retail', label: 'Retail' },
];

/** Given a balance and programId, compute estimated $ value */
export function estimateValue(programId, balance) {
  const program = LOYALTY_PROGRAMS_BY_ID.get(programId);
  if (!program) return 0;
  return (balance * program.cpp) / 100;
}

/** Given a balance and tier list, find the current tier name */
export function getCurrentTier(programId, qualifyingUnits) {
  const program = LOYALTY_PROGRAMS_BY_ID.get(programId);
  if (!program || !program.tiers.length) return 'Member';
  // find highest tier whose min <= qualifyingUnits
  let current = program.tiers[0];
  for (const tier of program.tiers) {
    if (qualifyingUnits >= tier.min) current = tier;
  }
  return current.name;
}

/** Returns next tier info: { name, min, progress (0-1) } or null if max tier */
export function getNextTier(programId, qualifyingUnits) {
  const program = LOYALTY_PROGRAMS_BY_ID.get(programId);
  if (!program) return null;
  const tiers = program.tiers;
  for (let i = 0; i < tiers.length; i++) {
    if (qualifyingUnits < tiers[i].min) {
      const prev = tiers[i - 1] || tiers[0];
      const progress =
        prev.min === tiers[i].min
          ? 1
          : (qualifyingUnits - prev.min) / (tiers[i].min - prev.min);
      return {
        name: tiers[i].name,
        min: tiers[i].min,
        remaining: tiers[i].min - qualifyingUnits,
        progress: Math.min(Math.max(progress, 0), 1),
      };
    }
  }
  return null; // already at max tier
}
